/**
 * Спільні константи застосунку.
 *
 * Раніше списки валют і способів оплати дублювалися в чотирьох компонентах,
 * а рядки "Готівка"/"Термінал"/"IBAN" перетворювалися на коди бекенду
 * ланцюжком if-else у трьох різних місцях. Тепер це одне джерело правди.
 */

/**
 * Версія застосунку. Раніше була захардкоджена в JSX екрана входу
 * і оновлювалася вручну; тепер її можна підставити зі змінної оточення
 * (наприклад, тегом збірки в CI).
 */
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.21.0';

export const CURRENCIES = ['UAH', 'USD', 'EUR'];

export const CURRENCY_OPTIONS = CURRENCIES.map((currency) => ({
    label: currency,
    value: currency,
}));

/**
 * Способи оплати. `value` — те, що зберігається у формі,
 * `apiType` — код, який очікує бекенд у accounting_payments/create/.
 */
export const PAYMENT_METHODS = [
    { label: 'Готівка', value: 'CASH', icon: 'pi pi-wallet' },
    { label: 'Термінал', value: 'CARD', icon: 'pi pi-credit-card' },
    { label: 'Рахунок (IBAN)', value: 'IBAN', icon: 'pi pi-building-columns' },
];

export const PAYMENT_METHOD_OPTIONS = PAYMENT_METHODS.map(({ label, value }) => ({
    label,
    value,
}));

/** Людська назва способу оплати за кодом бекенду. */
export const paymentMethodLabel = (value) =>
    PAYMENT_METHODS.find((method) => method.value === value)?.label ?? value;

/** Типи транзакцій у історії зміни. */
export const TRANSACTION_TYPES = {
    SALE: { label: 'Продаж', icon: 'pi pi-shopping-cart' },
    CASH_DEPOSIT: { label: 'Внесення готівки', icon: 'pi pi-arrow-down-left' },
    CASH_WITHDRAW: { label: 'Отримання готівки', icon: 'pi pi-arrow-up-right' },
    PAYMENT: { label: 'Оплата', icon: 'pi pi-credit-card' },
};

export const transactionLabel = (type) => TRANSACTION_TYPES[type]?.label ?? type;
export const transactionIcon = (type) => TRANSACTION_TYPES[type]?.icon ?? 'pi pi-circle';

/** Пункти головної навігації (нижній таб-бар + бічне меню). */
export const NAV_ITEMS = [
    { path: '/shift', label: 'Зміна', icon: 'pi pi-desktop' },
    { path: '/newsale', label: 'Продаж', icon: 'pi pi-shopping-cart', requiresOpenShift: true },
    { path: '/opensales', label: 'Замовлення', icon: 'pi pi-clipboard' },
    { path: '/salehistory', label: 'Історія', icon: 'pi pi-history' },
];

/** Українська локаль для компонента Calendar. */
export const UA_LOCALE = {
    firstDayOfWeek: 1,
    dayNames: ['неділя', 'понеділок', 'вівторок', 'середа', 'четвер', 'п’ятниця', 'субота'],
    dayNamesShort: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
    dayNamesMin: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
    monthNames: [
        'січень',
        'лютий',
        'березень',
        'квітень',
        'травень',
        'червень',
        'липень',
        'серпень',
        'вересень',
        'жовтень',
        'листопад',
        'грудень',
    ],
    monthNamesShort: [
        'січ',
        'лют',
        'бер',
        'кві',
        'тра',
        'чер',
        'лип',
        'сер',
        'вер',
        'жов',
        'лис',
        'гру',
    ],
    today: 'Сьогодні',
    clear: 'Очистити',
};
